import React from 'react';
import { useTheme } from '@mui/material/styles';
import Main from 'layouts/Main';
import Oly from './Oly';
import Oly21 from './Oly21';
import Oly22 from './Oly22';

import Container from 'components/Container';

import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import Oly23 from './Oly23';
import Scholastic from './Scholastic';
import Oly24 from './Oly24';
import Oly25 from './Oly25';

const analytics = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-X34JYK01Q0']
    })
  ]
})

analytics.page()


const Olympiad = () => {
  const theme = useTheme();
  return (
    <Main>
      <Container>
        {/* <Scholastic/> */}
        <Oly25/>
        <Oly24/>
        <Oly23 />
        <Oly22 />
        <Oly/>
        <Oly21 />
        
      </Container>
      <Container>
       
      </Container>
   
    </Main>
  );
};

export default Olympiad;
